export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6387.9b0a2990.jpg";